/**
 * Deterministic timeline sampling helpers for offline export.
 */

export interface TimelineFrame {
  frameIndex: number
  timeMs: number
  delayMs: number
}

export function getTotalFrames(durationSec: number, fps: number): number {
  return Math.max(1, Math.round(durationSec * fps))
}

export function getFrameTimeMs(frameIndex: number, fps: number): number {
  if (fps <= 0) {
    throw new Error('fps must be greater than 0')
  }

  return (frameIndex / fps) * 1000
}

export function createFrameTimeline(durationSec: number, fps: number): TimelineFrame[] {
  const totalFrames = getTotalFrames(durationSec, fps)
  const delayMs = 1000 / fps

  return Array.from({ length: totalFrames }, (_, frameIndex) => ({
    frameIndex,
    timeMs: getFrameTimeMs(frameIndex, fps),
    delayMs,
  }))
}
